export const USER_FIELDS = {
  email: 'email',
  token: 'token',
  password: 'password',
  password2: 'password2',
  oldPassword: 'old_password', //usato solo per edit password
  id: 'id',
  name: 'firstname',
  surname: 'lastname',
  group: 'group',
  group_id: 'group_id',
  status: 'status',
  status_id: 'status_id',
  creation_date: 'creation_date',
  last_update_date: 'last_update_date',
  created_by: 'created_by',
  last_updated_by: 'last_updated_by',
  notifications: 'notifications',
  notifications__id: 'notification_event_id',
  notifications__email: 'is_email',
  notifications__push: 'is_push',
  user_type: 'user_type',
  user_type_id: 'user_type_id'
};

export const ORDER_FIELDS = {
  id: 'id',
  reference: 'reference',
  status: 'status',
  status_id: 'status_id',
  creation_date: 'creation_date',
  last_update_date: 'last_update_date',
  created_by: 'created_by',
  last_updated_by: 'last_updated_by',
  customer: 'customer',
  customer_id: 'customer_id',
  deposit: 'deposit',
  order_start_date: 'start_date',
  order_end_date: 'end_date',
  final_findings: 'is_definitive_survey',
  findings_notes: 'survey',
  to_be_worked: 'is_progression_skippable',
  phases: 'progressions',
  substatus: 'substatus',
  seller: 'user_creator',
  seller_id: 'created_by', //è corretto che è created_by
  order_type: 'category',
  order_type_id: 'category_id',
  received_deposits: 'is_deposit_complete',
  year: 'year',
  progressive: 'progressive_number'
};

export const ORDER_PHASES_FIELDS = {
  start_date: "start_date",
  end_date: "end_date",
  effective_end_date: "effective_end_date",
  creation_date: 'creation_date',
  last_update_date: 'last_update_date',
  created_by: 'created_by',
  last_updated_by: 'last_updated_by',
  attachments: 'files',
  attachments_upload: 'file_ids',
  attachments_upload_type: 'file_type',
  order_id: 'commission_id',
  status_id: 'progression_status_id',
  status: 'progression_status',
  substatus: 'substatus',
  progression_id: 'id',
  notes: 'notes'
};

export const ORDER_ATTACHMENT_FIELDS = {
  creation_date: 'creation_date',
  last_update_date: 'last_update_date',
  created_by: 'created_by',
  last_updated_by: 'last_updated_by',
  media: 'media',
  media_id: 'media_id'
};

export const MEDIA_FIELDS = {
  id: 'id',
  name: 'filename',
  stored_name: 'stored_name',
  description: 'description',
  category_id: 'category_id',
  category: 'category',
  progression_id: 'progression_id',
  file: 'file'
};

export const GROUP_FIELDS = {
  id: 'id',
  name: 'name',
  status: 'status',
  status_id: 'status_id',
  creation_date: 'creation_date',
  last_update_date: 'last_update_date',
  created_by: 'created_by',
  last_updated_by: 'last_updated_by',
  group_permissions: 'group_permissions',
  user_count: 'user_count'
};

export const GROUP_PERMISSIONS_FIELDS = {
  progression_id: 'progression_id',
  read: 'is_read',
  write: 'is_write'
};

export const CUSTOMER_FIELDS = {
  id: 'id',
  name: 'business_name',
  vat_code: 'vat',
  phone: 'phone',
  email: 'email',
  tax_code: 'fiscal_code',
  address: 'address',
  city: 'city',
  prov: 'province',
  zip: 'zip_code',
  pec: 'pec',
  sdi: 'sdi',
  status: 'status',
  status_id: 'status_id',
  creation_date: 'creation_date',
  last_update_date: 'last_update_date',
  created_by: 'created_by',
  last_updated_by: 'last_updated_by',
  is_business: 'is_business',
  first_name: 'name',
  surname: 'surname'
};

export const PAGINATED_RESULTS_FIELDS = {
  items: 'result',
  total: 'count',
  pages: 'count_pages',
  page: 'page',
  page_size: 'page_size'
};

export const GLOBAL_CONFIG = {
  RESULT_PER_PAGE: 'results_per_page',
  DAYS_COMMISSION_END: 'days_commission_end',
  DAYS_PROGRESSION_END: 'days_progression_end',
  DAYS_OVERDUE: 'days_overdue',
  DAYS_PHASE_X_END: 'days_phase_XX_end'
};

export const UPLOAD_TYPES_FIELDS = {
  id: 'id',
  name: 'name',
  description: 'description',
  status: 'status',
  status_id: 'status_id',
  creation_date: 'creation_date',
  last_update_date: 'last_update_date',
  created_by: 'created_by',
  last_updated_by: 'last_updated_by'
};

export const ORDER_TYPES_FIELDS = {
  id: 'id',
  name: 'name',
  description: 'description',
  status: 'status',
  status_id: 'status_id',
  creation_date: 'creation_date',
  last_update_date: 'last_update_date',
  created_by: 'created_by',
  last_updated_by: 'last_updated_by'
};
